import { useAllTokenData, useUpdateTokenData, useAddTokenKeys, useTokensLoading } from './hooks'
import { useEffect, useMemo } from 'react'
import { useTokenDayDatas } from 'graphql/thegraph/tokens/tokenDayData'
import { useFetchedTokenDatas } from 'graphql/thegraph/tokens/tokenData'

export default function TokenUpdater(): null {
  // updaters
  const updateTokenDatas = useUpdateTokenData()
  const addTokenKeys = useAddTokenKeys()

  const [, updateTokenLoading] = useTokensLoading()

  // intitial data
  const allTokenData = useAllTokenData()
  const { loading, error, addresses } = useTokenDayDatas()

  // add top pools on first load
  useEffect(() => {
    if (addresses && !error && !loading) {
      addTokenKeys(addresses)
    }
  }, [addTokenKeys, addresses, error, loading])

  // detect for which addresses we havent loaded token data yet
  const unfetchedTokenAddresses = useMemo(() => {
    return Object.keys(allTokenData).reduce((accum: string[], key) => {
      const tokenData = allTokenData[key]
      if (!tokenData || !tokenData.data || !tokenData.lastUpdated) {
        accum.push(key)
      }
      return accum
    }, [])
  }, [allTokenData])

  // update unloaded pool entries with fetched data
  const {
    error: tokenDataError,
    loading: tokenDataLoading,
    data: tokenDatas,
  } = useFetchedTokenDatas(unfetchedTokenAddresses)

  useEffect(() => {
    if (tokenDatas && !tokenDataError && !tokenDataLoading) {
      updateTokenDatas(Object.values(tokenDatas))
    }
  }, [tokenDataError, tokenDataLoading, tokenDatas, updateTokenDatas])

  useEffect(() => {
    if (loading || tokenDataLoading) {
      updateTokenLoading(true)
    } else {
      updateTokenLoading(false)
    }
  }, [loading, tokenDataLoading])

  return null
}
